document.addEventListener('DOMContentLoaded', () => {
  function handleSizeSelect(event) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    const buttons = event.currentTarget.parentElement.querySelectorAll('.size-option');
    buttons.forEach((button) => button.classList.remove('selected'));
    event.target.classList.add('selected');

    const selectedVariantId = event.target.getAttribute('data-variant-id');
    if (!selectedVariantId) {
      alert('This size is not available.');
      return;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        items: [
          {
            id: selectedVariantId,
            quantity: 1,
          },
        ],
      }),
    })
      .then((response) => response.json())
      .then(() => {
        updateCartCount(); 
        document.body.classList.add('cart-has-items');
      })
      .catch((error) => {
        console.error('Error adding product to cart:', error);
      });
  }

  function updateCartCount() {
    fetch('/cart.js', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((cart) => {
        const cartCount = cart.item_count || 0;
        const cartIcon = document.querySelector('.cart-count');
        console.log(cart);
        if (cartIcon) {
          cartIcon.textContent = cartCount;
        }
        if (cartCount > 0) {
          document.body.classList.add('cart-has-items');
        }
        theme.cart.getCart().then(function(cart) {
          document.dispatchEvent(new Event('cart:build'));
        });
      })
      .catch((error) => {
      });
  }

  document.querySelectorAll('.size-option').forEach((button) => {
    button.addEventListener('click', handleSizeSelect);
  });

  updateCartCount(); 
});